import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ISchool } from '../../../models/schools.model';
import { doCreateSchool } from '../../../store/school.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/school/Editor';
import {
  errorVariant,
  successVariant,
  warningVariant,
} from '../../../lib/barVariant';

const SystemSchoolCreate: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.school);

  const onSubmit = async (req: ISchool) => {
    const res = await dispatch(doCreateSchool(req));

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);
        history.push(`/system/school${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.school.title2')}
      />
      <Editor school={null} onSubmit={onSubmit} />
      <Footer />
    </div>
  );
};

export default SystemSchoolCreate;
